import { render, staticRenderFns } from "./RowItemAligned.vue?vue&type=template&id=15ce4cf9&scoped=true"
import script from "./RowItemAligned.vue?vue&type=script&lang=js"
export * from "./RowItemAligned.vue?vue&type=script&lang=js"
import style0 from "./RowItemAligned.vue?vue&type=style&index=0&id=15ce4cf9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ce4cf9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
